import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RelatedCardFacade } from '@ridango/components';
import { RelatedCard } from '@ridango/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'rwidget-bank-cards-edit-form',
    templateUrl: './bank-cards-edit-form.component.html',
    styleUrls: ['./bank-cards-edit-form.component.scss']
})
export class BankCardsEditFormComponent implements OnInit, OnDestroy {
    @Output() formChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    public formGroup: FormGroup;
    private subs = new Subscription();

    constructor(private relatedCardFacade: RelatedCardFacade) {}

    ngOnInit(): void {
        this.subs.add(
            this.relatedCardFacade.selectedCard$.pipe(take(1)).subscribe((card: RelatedCard) => {
                this.formGroup = new FormGroup({
                    cardNumber: new FormControl(
                        { value: `************${card?.emv_card_info?.pan_last_digits}`, disabled: true },
                        [Validators.required]
                    ),
                    name: new FormControl(card?.name ?? card.emv_card_info?.scheme ?? '', [Validators.required])
                });
                this.formChange.emit(this.formGroup);
            })
        );
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
